export const aanvraagVozdEn = {
  AanvraagVozdMijnZorggegevens: "My healthcare details",
  AanvraagVozdMijnGegevens: "My details"
};
